import React from "react";
import { CustomCard } from "../../CustomCard";
import { Box } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";

// styles
import useStyles from "./styles";

function PredefinedPaymentPlanCardSkeleton({}) {
  const styles = useStyles();

  return (
    <CustomCard
      classes={styles.cardStyle}
      borderRadius="xl"
      borderColor="secondary"
    >
      <Box className={styles.leftSection}>
        <Skeleton animation="wave" variant="text" width="50%" height={55} />
        <Skeleton animation="wave" variant="text" width="60%" height={24} />
        <Skeleton animation="wave" variant="text" width="60%" height={24} />
        <Skeleton animation="wave" variant="text" width="60%" height={24} />
      </Box>
      <Box className={styles.middleSection}>
        {[...Array(4)].map((_, index) => (
          <Box className={styles.middleInfo} key={index}>
            <Skeleton
              animation="wave"
              variant="circle"
              width={24}
              height={24}
            />
            <Skeleton animation="wave" variant="text" width="45%" height={24} />
          </Box>
        ))}
      </Box>
      <Box className={styles.rightSection}>
        <Skeleton
          animation="wave"
          variant="rectangular"
          width={105}
          height={36}
          className={styles.buttonSkeleton}
        />
      </Box>
    </CustomCard>
  );
}

export default PredefinedPaymentPlanCardSkeleton;
